/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum HostSystem {
    CLASSIC = 'classic',
    GENERAL = 'general',
    KEAP_WEB = 'keap-web',
    MARKETING_CENTER = 'marketing-center',
}
